import "@frog/source/index.less"

////////////////
// Game Loop //
//////////////

import App from "@frog/source/models/App.js"
import Dev from "@frog/source/models/dev/Dev.js"

import Loop from "@frog/source/engine/Loop.js"
import Render from "@frog/source/engine/Render.js"
import Audiomix from "@frog/source/engine/Audiomix.js"

Loop.start(function(delta) {
    Dev.atStartOfLoop()

    Audiomix.update(delta)
    App.update(delta)
    Render()

    Dev.atEndOfLoop()
})

////////////////
// Analytics //
//////////////

import "@frog/source/analytics.js"

///////////////////
// Key Defaults //
/////////////////

window.addEventListener("keydown", (event) => {
    if(event.key == "s"
    && event.metaKey == true) {
        event.preventDefault()
    }
})

window.addEventListener("DOMContentLoaded", (event) => {
    LogTime("DomContentLoaded Time")
})

window.addEventListener("load", (event) => {
    LogTime("Full Load Time")
})

function LogTime(label) {
    const time = window.performance.now()
    console.info("%c" + time.toFixed(2) + "ms " + label, time >= 2000 ? "color: red" : "")
}

window.addEventListener("mouseup", (event) => {
    event.preventDefault()
})

window.addEventListener("keydown", (event) => {
    if(event.altKey == true
    || event.metaKey == true) {
        event.preventDefault()
    }
})

window.addEventListener("beforeunload", (event) => {
    return "Are you sure you want to leave the page? You will lose all progress."
})
